import { Route } from "react-router-dom";
import { _adr } from "../address";
import { Roles } from "../tools/services";
import { ProtectedRoute } from "../tools/protectedRoute";
import DAValid from "../components/deliveryArea/delivery/valid/daValid";
import DAKit from "../components/deliveryArea/delivery/kit/daKit";
import DaPrefactor from "../components/deliveryArea/delivery/prefactor/daprefactor";
import DADocument from "../components/deliveryArea/delivery/document/daDocument";
import DAFinal from "../components/deliveryArea/delivery/final/daFinal";
import DAListPendingDocument from "../components/deliveryArea/pending/list/daListPendingDocument";
import DAPendingDocument from "../components/deliveryArea/pending/document/daPendingDocument";

export const deliveryAreaRoutes = [
	// کارتابل تحویل حضوری
	<Route
		key="da-valid"
		path={_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Valid}
		element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas} element={DAValid} />}
	/>,
	<Route
		key="da-kit"
		path={_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Kit}
		element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas} element={DAKit} />}
	/>,
	<Route
		key="da-prefactor"
		path={_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Prefactor}
		element={<ProtectedRoute role={Roles.Dealer_SimSwap_Can_PickupMethodOfReceipt} element={DaPrefactor} />}
	/>,
	<Route
		key="da-document"
		path={_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Document}
		element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas} element={DADocument} />}
	/>,
	<Route
		key="da-final"
		path={_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Final}
		element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas} element={DAFinal} />}
	/>,

	// در انتظار آپلود مدارک
	<Route
		key="da-pending-list"
		path={_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Pending.Index + _adr.DeliveryArea.Pending.List}
		element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas_UploadingDoc} element={DAListPendingDocument} />}
	/>,
	<Route
		key="da-pending-upload"
		path={_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Pending.Index + _adr.DeliveryArea.Pending.upload}
		element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas_UploadingDoc} element={DAPendingDocument} />}
	/>,
];
